import { useGlobalStore as usePriceGlobalStore } from '@wegic/price-ui';
import { logHelper } from '@wegic/utils';
import { filterPricingProductsForSubscription } from '@/helpers/pricingProductsForUser';
import { getProductsRequest } from '@/services/user';
import { usePricingModalStore } from '@/stores/pricingModal';
import { useUserStore } from '@/stores/user';

const SILENT_BACKGROUND_REQUEST_CONFIG = {
  hideCodeErrorMessage: true,
  hideHTTPErrorMessage: true,
};

/**
 * 登录成功 or 应用启动(已登录)后调用一次，拉取产品列表到 store 中
 */
export async function initProductList(): Promise<void> {
  try {
    const res = await getProductsRequest(SILENT_BACKGROUND_REQUEST_CONFIG);
    if (res.code === 0 && res.data?.products) {
      const products = await filterPricingProductsForSubscription(
        res.data.products,
        useUserStore.getState().userSubscription,
      );
      usePricingModalStore.getState().setProductList(products);
      usePriceGlobalStore.getState().setProducts(products);
    }
  } catch (error) {
    logHelper.warn('[initProductList] load products failed:', error);
  }
}
